module.exports = __webpack_public_path__ + "static/media/campaign1.e3e88ea1.jpg";